import React from 'react';
import classNames from "classnames";

import {CheckCircleIcon} from "../icons/CheckCircleIcon";
import {InfoIcon} from "../icons/InfoIcon";
import {WarningIcon} from "../icons/WarningIcon";
import {DangerIcon} from "../icons/DangerIcon";


import './SectionMessage.css';


export type SectionMessageVariant = 'default' | 'error' | 'success' | 'warning' | 'info';

export interface SectionMessageProps {
    message: string | React.ReactNode;
    title?: string;
    className?: string;
    maxWidth?: string;
    variant: SectionMessageVariant;
}

export const SectionMessage = React.forwardRef<HTMLDivElement, SectionMessageProps>((
    {
        message,
        title,
        className,
        variant,
        maxWidth,
    },
    ref
) => {
    const Icon = getVariantIcon(variant);
    const style = maxWidth ? {maxWidth} : {};
    return (
        <div
            className={classNames({
                'SectionMessage': true,
                [className!]: !!className,
                'SectionMessage--success': variant === 'success',
                'SectionMessage--info': variant === 'info',
                'SectionMessage--warning': variant === 'warning',
                'SectionMessage--error': variant === 'error',
            })}
            ref={ref}
            style={style}
        >
            <div className='SectionMessage-header-line'>
                {Icon ? <Icon size={16} className={'SectionMessage-icon'}/> : null}
                <div className={'SectionMessage-header body-large-bold'}>{title}</div>
            </div>
            <div className={'SectionMessage-message body-large'}>{message}</div>
        </div>
    )
});

export const getVariantIcon = (variant: SectionMessageVariant) => {
    switch (variant) {
        case "info":
            return InfoIcon;
        case "success":
            return CheckCircleIcon;
        case "warning":
            return WarningIcon;
        case "error":
            return DangerIcon;
        case "default":
        default:
            return null;
    }
}